/**
 * Collection Grid: Mobile Slider (Women's Bottoms)
 * Handles the horizontal slider for filter images on mobile view.
 * Supports prev/next buttons and auto-recalculates on window resize.
 *
 * Extracted from main-collection-product-grid.liquid (pure JS, no Liquid)
 */
document.addEventListener('DOMContentLoaded', function () {
  const slider = document.getElementById('WomensBottomsSlider');
  if (!slider) return;

  const slides = slider.querySelectorAll('.slider__slide');
  if (slides.length === 0) return;

  const container = slider.closest('.womens-bottom-slider') || slider.parentElement;
  if (!container) return;

  const prevBtn = document.querySelector('.slider-button--prev');
  const nextBtn = document.querySelector('.slider-button--next');
  if (!prevBtn || !nextBtn) return;

  // Force 3 visible slides initially
  let visibleSlides = 3;
  if (visibleSlides > slides.length) visibleSlides = slides.length;

  // Calculate gutter (gap or margin-right)
  const computedStyle = getComputedStyle(slider);
  let gutter = Number.parseInt(computedStyle.gap, 10) || 0;
  if (gutter === 0) {
    gutter = Number.parseInt(getComputedStyle(slides[0]).marginRight, 10) || 0;
  }

  const containerWidth = container.offsetWidth;
  let slideWidth = Math.round((containerWidth - (visibleSlides - 1) * gutter) / visibleSlides);

  // Set slide widths dynamically
  slides.forEach((slide) => {
    slide.style.width = `${slideWidth}px`;
    slide.style.flexShrink = '0';
  });

  // Set total slider width
  const totalWidth = Math.round(slides.length * slideWidth + (slides.length - 1) * gutter);
  slider.style.width = `${totalWidth}px`;
  slider.style.display = 'flex';
  slider.style.gap = `${gutter}px`;

  let currentIndex = 0;
  const maxIndex = Math.max(0, slides.length - visibleSlides);

  // Calculate exact end translate to snap and avoid white space
  const endTranslate = -(totalWidth - containerWidth);

  function updateSlider() {
    currentIndex = Math.max(0, Math.min(currentIndex, maxIndex));

    let translateX = -currentIndex * slideWidth;
    if (currentIndex === maxIndex) {
      translateX = endTranslate;
    }

    slider.style.transform = `translateX(${translateX}px)`;
    slider.style.transition = 'transform 0.3s ease-in-out';

    prevBtn.style.display = currentIndex === 0 ? 'none' : '';
    nextBtn.style.display = currentIndex >= maxIndex ? 'none' : '';
  }

  function navigate(direction) {
    if (direction === 'prev' && currentIndex > 0) {
      currentIndex--;
    } else if (direction === 'next' && currentIndex < maxIndex) {
      currentIndex++;
    }
    updateSlider();
  }

  prevBtn.addEventListener('click', () => navigate('prev'));
  nextBtn.addEventListener('click', () => navigate('next'));

  updateSlider();

  // Re-init on resize
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      const newContainerWidth = container.offsetWidth;
      const newSlideWidth = Math.round((newContainerWidth - (visibleSlides - 1) * gutter) / visibleSlides);
      slides.forEach((slide) => {
        slide.style.width = `${newSlideWidth}px`;
      });
      const newTotalWidth = Math.round(slides.length * newSlideWidth + (slides.length - 1) * gutter);
      slider.style.width = `${newTotalWidth}px`;
      slideWidth = newSlideWidth;
      updateSlider();
    }, 250);
  });
});
